<template>
	<div class="full page_container">

		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
<!-- 			<el-tab-pane label="快递公司" v-if="findChildren(167)!==-1" name="expresscompany" style="height: 100%;">
				<expresscompany-index />
			</el-tab-pane>		
			<el-tab-pane label="快递对账" v-if="findChildren(168)!==-1" name="expressreconciliation" style="height: 100%;">
				<expressreconciliation-index />
			</el-tab-pane>	 -->
			<el-tab-pane label="运费设置" v-if="findChildren(32)!==-1" name="delivery" style="height: 100%;">
				<delivery-index />
			</el-tab-pane>	
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	// import expresscompanyIndex from './expresscompany/index.vue'
	// import expressreconciliationIndex from './expressreconciliation/index.vue'
	import deliveryIndex from './delivery/index.vue'
	
	export default {
		props: {

		},
		data() {
			return {
				activeName: 'expressreconciliation',
				activeIndex: '',
				departmentChildren: []
			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				this.activeName = this.departmentChildren[0].controller
				//this.activeName = 'purchasestockbill'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			}
		},
		components: {
			// expresscompanyIndex,
			// expressreconciliationIndex,
			deliveryIndex
		}
	}
</script>